(() => {
  const runtime = window.BogerSections;
  if (!runtime) return;
  runtime.register('story-cinema', '[data-story-cinema]', (cinema, { signal, reducedMotion }) => {
    const chapters = [
      { kicker: '01 BEGIN WITH THE BOND', title: 'Better Outings. Closer Bonds.', support: 'Outdoor time does not have to be extreme to matter. Boger Pets is built around neighbourhood walks, park pauses and unhurried weekend outings—the familiar moments when a lead, a reward, a drink and a thoughtful clean-up help you stay present with the dog beside you.', cta: 'Begin with the bond', href: '#story-statement-title' },
      { kicker: '02 FOLLOW THE WHOLE WALK', title: 'Four roles, one clearer routine.', support: 'Connect. Reward. Hydrate. Clean.', cta: 'Shop Valley Walk Set', href: `${window.BogerPets.root}products/valley-walk-set` },
      { kicker: '03 SELECT WITH CLARITY', title: 'Selected and organised with clarity.', support: 'HiDREAM supplies the current products. Boger Pets selects them and organises how their roles work together.', cta: 'See how we select', href: '#story-method' },
      { kicker: '04 WALK WITH US', title: 'Everyday outings, shared.', support: 'Share the routines that make everyday walks feel more connected.', cta: 'Walk with us', href: cinema.dataset.walkUrl || `${window.BogerPets.root}pages/walk-with-us` }
    ];
    const cards = [...cinema.querySelectorAll('[data-story-card]')];
    const backgrounds = [...cinema.querySelectorAll('[data-story-background]')];
    const kicker = cinema.querySelector('[data-story-kicker]');
    const title = cinema.querySelector('[data-story-title]');
    const support = cinema.querySelector('[data-story-support]');
    const cta = cinema.querySelector('[data-story-cta]');
    const current = cinema.querySelector('[data-story-current]');
    const progress = cinema.querySelector('[data-story-progress]');
    if (!cards.length || !kicker || !title || !support || !cta) return;
    let activeIndex = 0;
    let pointerStartX = null;
    const render = (next, focusCard = false) => {
      activeIndex = (next + chapters.length) % chapters.length;
      const chapter = chapters[activeIndex];
      kicker.textContent = chapter.kicker;
      title.textContent = chapter.title;
      support.textContent = chapter.support;
      cta.textContent = chapter.cta;
      cta.href = chapter.href;
      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
      progress?.style.setProperty('--story-progress', String((activeIndex + 1) / chapters.length));
      cards.forEach((card, index) => {
        const selected = index === activeIndex;
        card.classList.toggle('is-active', selected);
        card.setAttribute('aria-pressed', String(selected));
      });
      backgrounds.forEach((background, index) => background.classList.toggle('is-active', index === activeIndex && background.dataset.failed !== 'true'));
      cinema.classList.toggle('has-image-failure', backgrounds[activeIndex]?.dataset.failed === 'true');
      const activeCard = cards[activeIndex];
      const track = activeCard?.parentElement;
      if (track && track.scrollWidth > track.clientWidth) activeCard.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
      if (focusCard) cards[activeIndex]?.focus({ preventScroll: true });
    };
    cards.forEach((card, index) => {
      card.dataset.chapterSlot = String(index + 1).padStart(2, '0');
      card.addEventListener('click', () => render(Number(card.dataset.storyIndex)), { signal });
    });
    cinema.querySelector('[data-story-previous]')?.addEventListener('click', () => render(activeIndex - 1), { signal });
    cinema.querySelector('[data-story-next]')?.addEventListener('click', () => render(activeIndex + 1), { signal });
    cinema.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('input,select,textarea')) return;
      event.preventDefault();
      render(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
    }, { signal });
    cinema.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') pointerStartX = event.clientX; }, { signal, passive: true });
    cinema.addEventListener('pointerup', event => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) >= 48) render(activeIndex + (distance < 0 ? 1 : -1));
    }, { signal, passive: true });
    cinema.addEventListener('pointercancel', () => { pointerStartX = null; }, { signal });
    backgrounds.forEach(background => background.addEventListener('error', () => {
      background.dataset.failed = 'true';
      background.classList.remove('is-active');
      if (Number(background.dataset.storyIndex) === activeIndex) cinema.classList.add('has-image-failure');
    }, { signal }));
    render(0);
  });
})();
